module.exports = __webpack_public_path__ + "img/Mysteries.11113b16.webp";